/* eslint-disable react-hooks/exhaustive-deps */
/* หน้าแรกของลูกค้า: บ้านของฉัน (เฉพาะโปรเจ็กต์ที่เป็นเจ้าของ) */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Card, Empty, Flex, Spin, Tag, Typography, message } from "antd";
import { BsHouseDoor } from "react-icons/bs";
import { RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import StatusTag from "../components/ak/StatusTag";
import { fileUrl } from "../utils/util";
import { Portal, perr } from "./portalApi";
import { usePortalMe } from "./PortalLayout";

export default function PortalHome() {
  const navigate = useNavigate();
  const me = usePortalMe();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    Portal.projects()
      .then((r) => setRows(r.data.data || []))
      .catch((e) => {
        setRows([]);
        message.error(perr(e));
      });
  }, []);

  return (
    <div>
      <Typography.Title level={4} className="!mb-1">
        สวัสดี {me?.name}
      </Typography.Title>
      <Typography.Text type="secondary">บ้านของท่านกับ AK HOME — ดูแบบบ้าน เอกสาร และแจ้งขอเปลี่ยนแปลง (RC)</Typography.Text>

      <div className="pt-list">
        {rows === null ? (
          <Flex justify="center" style={{ padding: 40 }}>
            <Spin />
          </Flex>
        ) : rows.length === 0 ? (
          <Card className="pt-card">
            <Empty description="ยังไม่มีโปรเจ็กต์ที่ผูกกับบัญชีนี้ กรุณาติดต่อเจ้าหน้าที่" />
          </Card>
        ) : (
          rows.map((p) => (
            <Card key={p.project_code} className="pt-card pt-project" hoverable onClick={() => navigate(`project/${p.project_code}`)}>
              <Flex gap={14} align="center">
                <div className="pt-thumb">{p.model_image ? <img src={fileUrl(p.model_image)} alt="" /> : <BsHouseDoor />}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Typography.Text strong className="pt-project-name">
                    {p.project_name}
                  </Typography.Text>
                  <div className="pt-meta">
                    {p.model_code ? `แบบ ${p.model_code}${p.model_name ? ` ${p.model_name}` : ""}` : ""}
                    {p.site_province ? ` · ${[p.site_district, p.site_province].filter(Boolean).join(" ")}` : ""}
                  </div>
                  <Flex gap={6} wrap="wrap" style={{ marginTop: 6 }}>
                    <StatusTag value={p.status} />
                    {p.plan_latest ? <Tag color="green">แบบบ้าน v{p.plan_latest}</Tag> : null}
                    {Number(p.rc_open) > 0 && (
                      <Badge count={p.rc_open} size="small" offset={[4, 0]}>
                        <Tag color="orange">RC กำลังดำเนินการ</Tag>
                      </Badge>
                    )}
                    {p.start_date && <Tag>เริ่ม {dayjs(p.start_date).format("DD/MM/YYYY")}</Tag>}
                  </Flex>
                </div>
                <RightOutlined style={{ color: "#bfbfbf" }} />
              </Flex>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
